exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".RichEditor-editor .RichEditor-blockquote{border-left:5px solid #eee;color:#666;font-family:Hoefler Text,Georgia,serif;font-style:italic;margin:16px 0;padding:10px 20px}.RichEditor-editor .public-DraftStyleDefault-pre{background-color:rgba(0,0,0,.05);font-family:Inconsolata,Menlo,Consolas,monospace;font-size:16px;padding:20px}.RichEditor-controls{font-family:Helvetica,sans-serif;font-size:14px;margin-bottom:5px;user-select:none}.RichEditor-styleButton{color:#999;cursor:pointer;margin-right:16px;padding:2px 0}.RichEditor-activeButton{color:#5890ff}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/RichEditor.css
 ** module id = 777
 ** module chunks = 0
 **/